import { webServiceProvider, download } from '../shared';

const DIRECT_ENDPOINT = `${import.meta.env.VITE_API_URL}v1`;

class InspectionsStoreC {
  getTemplates = async (shopId, templateId) => {
    const abort = new AbortController();
    const url = `${DIRECT_ENDPOINT}/templates/${shopId}`;
    const { data } = await webServiceProvider.directFetchWithMethod(
      url,
      'GET',
      null,
      abort.signal
    );

    return data;
  };

  createTemplate = async (shopId, payload) => {
    const url = `${DIRECT_ENDPOINT}/templates/${shopId}`;
    const { data } = await webServiceProvider.directFetchWithMethod(
      url,
      'POST',
      payload
    );
    return data;
  };

  getTemplate = async (shopId, templateId) => {
    const abort = new AbortController();
    const url = `${DIRECT_ENDPOINT}/templates/${shopId}/${templateId}`;
    const { data } = await webServiceProvider.directFetchWithMethod(
      url,
      'GET',
      null,
      abort.signal
    );
    return data[0];
  };

  updateTemplate = async (shopId, payload) => {
    const url = `${DIRECT_ENDPOINT}/templates/${shopId}/${payload.form_id}`;
    const { data } = await webServiceProvider.directFetchWithMethod(
      url,
      'PATCH',
      payload
    );
    return data;
  };

  createInspectionForm = async (shopId, payload) => {
    const url = `${DIRECT_ENDPOINT}/inspection-forms/${shopId}`;
    const { data } = await webServiceProvider.directFetchWithMethod(
      url,
      'POST',
      payload
    );
    return data;
  };

  getInspectionForms = async (shopId, id = null) => {
    const abort = new AbortController();
    const url = `${DIRECT_ENDPOINT}/inspection-forms/${shopId}${id !== null ? `?carId=${id}` : ''}`;
    const { data } = await webServiceProvider.directFetchWithMethod(
      url,
      'GET',
      null,
      abort.signal
    );

    return data;
  };

  getInspectionForm = async (shopId, formId) => {
    const abort = new AbortController();
    const url = `${DIRECT_ENDPOINT}/inspection-forms/${shopId}/${formId}`;
    const { data } = await webServiceProvider.directFetchWithMethod(
      url,
      'GET',
      null,
      abort.signal
    );

    return data;
  };

  updateForm = async (shopId, payload) => {
    const url = `${DIRECT_ENDPOINT}/inspection-forms/${shopId}/${payload.form_id}`;
    const { data } = await webServiceProvider.directFetchWithMethod(
      url,
      'PATCH',
      payload
    );
    return data;
  };

  downloadFormPdf = async (shopId, formId) => {
    const abort = new AbortController();
    const url = `v1/inspection-forms/${shopId}/${formId}/pdf`;
    const data = await webServiceProvider.getPDF(url);
    download(data, `inspection-form-${formId}.pdf`, 'application/pdf');
  };

  deleteForm = async (shopId, formId) => {
    const abort = new AbortController();
    const url = `v1/inspection-forms/${shopId}/${formId}`;
    const { data } = await webServiceProvider.delete(url, abort.signal);
    return data;
  };

  deleteTemplate = async (shopId, templateId) => {
    const abort = new AbortController();
    const url = `v1/templates/${shopId}/${templateId}`;
    const { data } = await webServiceProvider.delete(url, abort.signal);
    return data;
  };
}

const InspectionsStore = new InspectionsStoreC();
export default InspectionsStore;
